<script src="../../../assets/js/jquery.audioslideshow.js"></script>
<template>
    <div data-v-953aaa6a="" class="lab-operation" data-v-20323194="" style="margin-top: -9px;">
        <div data-v-7ed5db42="" data-v-953aaa6a="" class="section-box-root">
            <div data-v-50734e5a="" data-v-7ed5db42="" class="intro-container" style="height: 100%;width: 100%">
                <div data-v-50734e5a="" class="intro-root">
                    <div data-v-48901454="" data-v-7ed5db42="" class="left-box" data-v-50734e5a=""
                         style="width: 100%;">
                        <div data-v-48901454="" class="left-bar">
                            <div data-v-7ed5db42="" data-v-48901454="" class="left-bar">
                                <div data-v-7ed5db42="" data-v-48901454="" class="menu-tabs"
                                     style="border-bottom: 1px solid #eee;">
                                    <div data-v-7ed5db42="" data-v-48901454="" class="item font-16"
                                         :class="show_content_tag.show_description ? 'active' : ''"
                                         @click="change_show_content('description')">
                                        介绍
                                    </div>
                                    <div data-v-7ed5db42="" data-v-48901454="" class="item font-16"
                                         :class="show_content_tag.show_question ? 'active' : ''"
                                         @click="change_show_content('question')">
                                        讨论
                                    </div>
                                    <div data-v-7ed5db42="" data-v-48901454="" class="item font-16"
                                         :class="show_content_tag.show_summary ? 'active' : ''"
                                         @click="change_show_content('summary')">
                                        心得
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div data-v-48901454="" class="box-container relative">

                            <div data-v-48901454="" class="box-content relative full-width">
                                <div v-if="show_content_tag.show_description" data-v-1c5d4594="" data-v-7ed5db42=""
                                     class="lab-document"
                                     data-v-48901454=""><!---->
                                    <div data-v-1f671898="" data-v-1c5d4594="" class="steps-document"
                                         width="482" style="height: 100%;"><!----> <!---->
                                        <div data-v-1fd30953="" data-v-1f671898="" class="step-content">
                                            <!--<div data-v-1fd30953="" class="title"><i data-v-1fd30953="" class=""></i>-->
                                            <!--<div data-v-1fd30953="">-->
                                            <!--课程介绍-->
                                            <!--</div>-->
                                            <!--<i data-v-1fd30953="" class=""></i>-->
                                            <!--</div>-->
                                            <div data-v-1fd30953="" class="markdown-body"
                                                 style="background-color: white;border-bottom: 1px solid #eee;padding: 16px">
                                                <div data-v-1fd30953="" class="markdown-content">
                                                    <div v-if="lesson_info.description" v-html="lesson_info.description.replace(/\n/g,'<br/>')"></div>
                                                    <div>知识点：{{lesson_info.points}}</div>
                                                </div>
                                            </div>
                                            <!--<div data-v-1fd30953="" class="title"><i data-v-1fd30953="" class=""></i>-->
                                            <!--<div data-v-1fd30953="">-->
                                            <!--导师介绍-->
                                            <!--</div>-->
                                            <!--<i data-v-1fd30953="" class=""></i>-->
                                            <!--</div>-->
                                            <CourseTeacher></CourseTeacher>
                                            <!--<div data-v-1fd30953="" class="markdown-body">-->
                                            <!--<img class="" :src="lesson_info.teacher.avatar_url">-->
                                            <!--<div style="float: right;width: 80%;padding-left: 5px;"-->
                                            <!--v-html="lesson_info.teacher.description.replace(/\n/g,'<br/>')"></div>-->
                                            <!--</div>-->
                                        </div>
                                        <!--<div data-v-9a844362="" data-v-1f671898="" class="tools">-->
                                        <!--<div data-v-9a844362="" class="progress progress">-->
                                        <!--<div role="progressbar" aria-valuemin="0" aria-valuemax="17"-->
                                        <!--aria-valuenow="13" class="progress-bar"-->
                                        <!--style="width: 76.4706%;">&lt;!&ndash;&ndash;&gt;</div>-->
                                        <!--</div> &lt;!&ndash;&ndash;&gt; <a data-v-9a844362="" href="javascript:;"-->
                                        <!--class="tools-catalog-btn"><i-->
                                        <!--data-v-9a844362="" class="fa fa-list-ul"></i></a>-->
                                        <!--<div data-v-9a844362="">&lt;!&ndash;&ndash;&gt;-->
                                        <!--<button data-v-9a844362="" type="button"-->
                                        <!--class="btn tools-btn btn-primary">-->
                                        <!--下一步-->
                                        <!--</button>-->
                                        <!--</div>-->
                                        <!--</div>-->
                                    </div> <!----> <!----> <!----></div>
                                <div v-if="show_content_tag.show_summary" data-v-4bca5bf5="" data-v-7ed5db42=""
                                     class="lab-console-report"
                                     data-v-48901454="" style="background-color: white"><!---->
                                    <!--<div class="publish_tools">-->
                                    <!--<div class="publish_operation_tools">-->
                                    <!--<button class="publish_button publish_preview_button" @click="tab_preview()"-->
                                    <!--v-show="!preview">预览-->
                                    <!--</button>-->
                                    <!--<button class="publish_button publish_preview_button" @click="tab_preview()"-->
                                    <!--v-show="preview">取消预览-->
                                    <!--</button>-->
                                    <!--<button class="publish_button" @click="publish">发布</button>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                    <ul data-v-4bca5bf5="" class="nav nav-tabs">
                                        <li data-v-4bca5bf5="" class="nav-item"><a data-v-4bca5bf5=""
                                                                                   class="nav-link"
                                                                                   :class="preview ? '':'active'"
                                                                                   @click="tab_preview('false')">
                                            编辑
                                        </a></li>
                                        <!--<li data-v-4bca5bf5="" class="nav-item"><a data-v-4bca5bf5=""-->
                                                                                   <!--class="nav-link"-->
                                                                                   <!--:class="preview ? 'active':''"-->
                                                                                   <!--@click="tab_preview('true')">-->
                                            <!--预览-->
                                        <!--</a></li>-->
                                    </ul>
                                    <!--<MarkdownEditor class="publish_markdown_editor" style="border: none"-->
                                                    <!--:placeholder="'心得是您在本课程保存的笔记、截图及感受的完整记录，多记录学习更高效哦~'"-->
                                                    <!--:preview="preview"-->
                                                    <!--@text="get_content">-->
                                    <!--</MarkdownEditor>-->
                                    <CKEditor @text="get_content"></CKEditor>
                                    <!--<ul data-v-4bca5bf5="" class="nav nav-tabs">-->
                                    <!--<li data-v-4bca5bf5="" class="nav-item"><a data-v-4bca5bf5=""-->
                                    <!--class="nav-link active">-->
                                    <!--编辑-->
                                    <!--</a></li>-->
                                    <!--<li data-v-4bca5bf5="" class="nav-item"><a data-v-4bca5bf5=""-->
                                    <!--class="nav-link">-->
                                    <!--预览-->
                                    <!--</a></li>-->
                                    <!--</ul>-->
                                    <!--<div data-v-4bca5bf5="" class="tab-content">-->
                                    <!--<div data-v-4bca5bf5="" class="tab-pane active lab-report-tab">-->
                                    <!--<div data-v-ea88a3ba="" data-v-4bca5bf5="" class="editor">-->
                                    <!--<div data-v-7a85cdd0="" data-v-ea88a3ba=""-->
                                    <!--class="markdown-editor">-->
                                    <!--<div data-v-5ba8e79f="" data-v-7a85cdd0=""-->
                                    <!--class="tools">-->
                                    <!--<div data-v-5ba8e79f=""><i data-v-5ba8e79f=""-->
                                    <!--class="fa fa-bold"></i>-->
                                    <!--<i data-v-5ba8e79f="" class="fa fa-italic"></i>-->
                                    <!--<i data-v-5ba8e79f="" class="fa fa-link"></i> <i-->
                                    <!--data-v-5ba8e79f=""-->
                                    <!--class="fa fa-quote-left"></i> <i-->
                                    <!--data-v-5ba8e79f=""-->
                                    <!--class="fa fa-code"></i> <i-->
                                    <!--data-v-5ba8e79f=""-->
                                    <!--class="fa fa-image add-image-btn"></i>-->
                                    <!--<div data-v-5ba8e79f=""-->
                                    <!--class="custom-file b-form-file upload-image"-->
                                    <!--id="__BVID__270__BV_file_outer_"><input-->
                                    <!--type="file" class="custom-file-input"-->
                                    <!--id="__BVID__270"><label-->
                                    <!--data-browse="Browse"-->
                                    <!--class="custom-file-label"-->
                                    <!--for="__BVID__270">No file chosen</label>-->
                                    <!--</div>-->
                                    <!--<i data-v-5ba8e79f="" class="fa fa-list-ol"></i>-->
                                    <!--<i data-v-5ba8e79f="" class="fa fa-list-ul"></i>-->
                                    <!--</div>-->
                                    <!--<a data-v-5ba8e79f=""-->
                                    <!--href="https://www.shiyanlou.com/questions/764/"-->
                                    <!--target="_blank" class="markdown-syntax"><i-->
                                    <!--data-v-5ba8e79f=""-->
                                    <!--class="fa fa-question-circle"></i>-->
                                    <!--格式说明-->
                                    <!--</a></div>-->
                                    <!--<textarea data-v-7a85cdd0="" placeholder="报告将自动保存，推荐使用 markdown 语法：-->

                                    <!--报告是您在本实验保存的笔记、截图及实验代码的完整记录，多记录学习更高效哦~" rows="10"-->
                                    <!--class="textarea form-control"></textarea> &lt;!&ndash;&ndash;&gt;</div>-->
                                    <!--<div data-v-4a2a5656="" data-v-ea88a3ba="">&lt;!&ndash;&ndash;&gt;-->
                                    <!--<div data-v-4a2a5656=""-->
                                    <!--class="custom-file b-form-file upload-image"-->
                                    <!--id="__BVID__272__BV_file_outer_"><input type="file"-->
                                    <!--class="custom-file-input"-->
                                    <!--id="__BVID__272"><label-->
                                    <!--data-browse="Browse" class="custom-file-label"-->
                                    <!--for="__BVID__272">No file chosen</label></div>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                    <!--</div> &lt;!&ndash;&ndash;&gt;</div>-->
                                    <button @click="publish" data-v-4bca5bf5="" type="button"
                                            class="btn publish-btn btn-primary "><i
                                            data-v-4bca5bf5="" class="fa fa-share"></i> <span
                                            data-v-4bca5bf5="">发布</span></button>
                                </div>
                                <div v-if="show_content_tag.show_question" data-v-24a59a0a="" data-v-7ed5db42=""
                                     class="lab-question"
                                     data-v-48901454="">
                                    <div data-v-38f43bd3="" data-v-24a59a0a="" class="operate">
                                        <button data-v-38f43bd3="" class="btn btn-primary"
                                                @click="_change_pubilsh_dialog('open')">
                                            提问
                                        </button>
                                        <PublishQuestion></PublishQuestion>
                                        <fieldset data-v-38f43bd3="" class="form-group form-group"
                                                  id="__BVID__275"><!---->
                                            <div tabindex="-1" role="group">
                                                <div data-v-38f43bd3=""
                                                     class="custom-control custom-checkbox"><input
                                                        type="checkbox" name="checkbox" autocomplete="off"
                                                        class="custom-control-input" value="true"
                                                        @click="_show_lesson_or_my_question"
                                                        id="__BVID__276"><label class="custom-control-label"
                                                                                for="__BVID__276">
                                                    只看我的
                                                </label></div><!----><!----><!----></div>
                                        </fieldset> <!---->
                                        <div data-v-38f43bd3="">
                                            <div id="publish-success-modal___BV_modal_outer_"
                                                 style="position: absolute; z-index: 1040;">
                                                <div id="publish-success-modal" role="dialog"
                                                     aria-hidden="true"
                                                     aria-describedby="publish-success-modal___BV_modal_body_"
                                                     class="modal fade publish-success-modal"
                                                     style="display: none;">
                                                    <div class="modal-dialog modal-md"><!---->
                                                        <div role="document"
                                                             id="publish-success-modal___BV_modal_content_"
                                                             tabindex="-1" class="modal-content">
                                                            <header id="publish-success-modal___BV_modal_header_"
                                                                    class="modal-header"><h5
                                                                    id="publish-success-modal___BV_modal_title_"
                                                                    class="modal-title"></h5>
                                                                <button type="button" aria-label="Close"
                                                                        class="close">×
                                                                </button>
                                                            </header>
                                                            <div id="publish-success-modal___BV_modal_body_"
                                                                 class="modal-body">
                                                                <hgroup class="title"><h4><img
                                                                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAmdJREFUSA21ls9rU0EQx2c2sWmCBVuphVh/QAsK1rZ4FlQUxR9YqtdeBHvw0GD/AvHkPT0a7EUPBYso2OJBrODNiwcFfyBoEX8heojEIr63znfztnm/+vKerQNhs5vZz8zOzs6EKUGKj6r9rPSYq/m0qA3Ip+ypf5TxrWJ9X7t899eRygdvPTJwZEUWSk9myu4ffZU0XSDSuTid1ho7xDSr8nylcXAKhgMSMVB6PHPW1e5NgXcFNNtNmOqK1UTj0NQ9v6ryT4pL1YrA72SGAyIOYS8YfubqCTzPAQ8Y9Sun+s7kyknG7UmMgWbM3Zf/5HmcVYQrr/biToy33oVmi3kc2K4hXEgSEUYqaqJ37bPF7k47siPh2S3h0mMbD4cTOge28h5RWrcCelvyBbq84wD1FzYH1u0E7LxM8EIzS7fAF0bGabRrGxVVjq69fxrHGMAl2+cfUIB353oHqYOjD9kPf9P4QTc+vQjs9U3Ka+b8pe3DdGvfKZrff4YK4qGVMPz4s3n68rthf46MMBCpH9Ca+/rabDzWs4tuDzWNxME/J8DB5s6l6gJpfRLQsOwpddOD0fPU11Gih9+XaeumThNzhAWet4HLI+BFhZIbBtv5KwGd8EJwtGdnNrhAwFao52LKsdDwaI0sr9Tp+c9v6Tw3EHbANrVIwnRdwnQxDPfPc8zkaHnzaYW5tnK4MmmyCM1CmkY9aW82OIqdMEWMAVP1pFmIETfJSKrfmuV6wna31XeA+s3E0+syInAwbC+AQ+YO/J7915YJQ7COZiE5XEvKrpZTaPpcMw0m1I+hEzlBayPRRvxt+QvzgQD15GCKOwAAAABJRU5ErkJggg==">
                                                                    发布成功
                                                                </h4> <h5>
                                                                    关注”实验楼学习助手“微信服务号，及时获得问题的回复提醒
                                                                </h5></hgroup>
                                                                <!--<img src="./新手入门指南之玩转实验楼 - 👋 你好，实验楼！ - 实验楼_files/97f0a22.png"-->
                                                                <!--alt="" class="qrcode">-->
                                                            </div><!---->
                                                        </div><!----></div>
                                                </div><!----></div>
                                        </div>
                                    </div>
                                    <div data-v-51d37e30="" data-v-24a59a0a="" class="best-question">
                                        <!----></div>
                                    <div data-v-6af612f6="" data-v-24a59a0a="" class="normal-question">
                                        <div data-v-3bf8678d="" data-v-6af612f6="" class="question-list"
                                             question-type="normal">
                                            <div data-v-3bf8678d="" class="list-title">
                                                课节问答({{lesson_info.questions.length}})
                                            </div>
                                            <ul data-v-3bf8678d="" style="height: 602px;">
                                                <li data-v-3bf8678d="" class="list-item"
                                                    v-for="question in lesson_info.questions"
                                                    :key="question['id']"><a
                                                        data-v-3bf8678d=""
                                                        :href="'/questions/'+question.id"
                                                        target="_blank"><!---->
                                                    <div class="qa_item_div">
                                                        <div class="qa_item_question_div">
                                                            <router-link tag="a"
                                                                         :to="{ name: 'user', params: { id: question.author.id } }">
                                                                <img :src="question.author.avatar_url"
                                                                     class="item_question_avatar"/>
                                                            </router-link>
                                                            <div class="item_question">
                                                                <router-link
                                                                        :to="{ name: 'question', params: { id: question.id } }"
                                                                        tag="a"
                                                                        class="item_question_title">
                                                                    {{question.title}}
                                                                </router-link>
                                                                <div class="item_question_content"
                                                                     v-if="question.content_description.length<=25">
                                                                    {{question.content_description}}
                                                                </div>
                                                                <div class="item_question_content" v-else>
                                                                    {{question.content_description.substring(0,25)}}......
                                                                </div>
                                                                <div class="item_question_base_info">
                                                                    <!--  -->
                                                                    <span class="margin-right-10"> {{question.author.name}}</span>
                                                                    <!--<span class="level margin-right-10">L{{question.author.level}}</span>-->
                                                                    <span>{{question.created_at}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                         <div class="item_view_answer_div">
                                                                    <div class="view_answer_div answer_number_div"
                                                                         style="margin-top: -16px;">
                                                                        <!--<span class="view_span view_answer_span">{{question.answers_count}}</span>-->
                                                                        <span class="view_span view_answer_span">{{question.answers_count}}回复</span>
                                                                    </div>
                                                                </div>
                                                    </div>
                                                </a>
                                                </li>
                                                <li data-v-3bf8678d="" class="load-msg"><span
                                                        data-v-3bf8678d="">到底了~</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script type="text/javascript">
    import MarkdownEditor from '@/components/common_components/markdown_editor/markdown.vue'
    import CKEditor from '@/components/common_components/ckeditor/ckeditor.vue'
    import PublishQuestion from '@/components/learning_page/sub_components/publish_question.vue'
    import CourseTeacher from '@/components/courses_page/course/sub_components/course_teacher.vue'
    import ReportsApi from '@/api/reports/reports.js'
    import {mapState, mapActions} from 'vuex'


    export default {
        data: function () {
            return {
                preview: false,
                content: '',
                only_my_question_tag: false
            }
        },
        components: {
            PublishQuestion,
            CourseTeacher,
            CKEditor,
            MarkdownEditor
        },
        computed: {
            ...mapState({
                sign_on: state => state.loginState.sign_on,
                lesson_info: state => state.learning.lesson_info,
                show_content_tag: state => state.learning.show_content_tag
            })
        },
        methods: {
            ...mapActions({
                change_show_content: 'learning/change_show_content',
                change_show_state: 'loginState/change_show_state',
                change_pubilsh_dialog: 'learning/change_pubilsh_dialog',
                show_lesson_or_my_question: 'learning/show_lesson_or_my_question',
                change_warning_message: 'warningBar/change_message',
                change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class'
            }),
            _change_pubilsh_dialog: function () {
                if (!this.sign_on) {
                    this.change_show_state('on')
                } else {
                    this.change_pubilsh_dialog('open')
                }
            },
            _show_lesson_or_my_question: function () {
                this.only_my_question_tag = !this.only_my_question_tag;

                var lessonId = this.$route.query.id;
                var questionParams = {'lessonId': lessonId, 'only_my_question_tag': this.only_my_question_tag}
                if (this.only_my_question_tag && !this.sign_on) {
                    questionParams = {}
                }
                this.show_lesson_or_my_question(questionParams)

            },
            tab_preview: function (p) {
                if (p == 'false') {
                    this.preview = false
                }
                if (p == 'true') {
                    this.preview = true
                }

            },
            get_content: function (content) {
                this.content = content
            },
            publish: async function () {
                if (!this.sign_on) {
                    this.change_show_state('on')
                } else {
                    var lesson_id = this.$route.query.id;
                    let res = await ReportsApi.post_labreports({
                        content: this.content,
                        lesson_id: lesson_id,
                    });
                    if (res.status === 200 && JSON.parse(res.data.result).code === 'success') {
                        this.change_warning_message("发布心得成功");
                        this.change_warning_bar_style_class('success');
                    }else{
                        this.change_warning_message(JSON.parse(res.data.result).message);
                        this.change_warning_bar_style_class('alert');
                    }
                }
            }
        }
    }

</script>
<style type="text/css" scoped>
    @import '../../../assets/css/content1.css';
    @import '../../../assets/css/content2.css';

    .content {
        width: 300px;
        height: 100%;
        float: left;
        /*background-color: red;*/
        border: 1px solid #ccc;
    }

    .lesson_info {
        margin: 0 5px;
        /*background-color: yellow;*/
    }

    .publish_button {
        padding: 6px 20px;
        background: rgb(8, 191, 145);
        border: 1px solid transparent;
        border-radius: 4px;
        font-size: 16px;
        text-align: center;
        color: #fff;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        margin-right: 5px;
    }

    .publish_preview_button {
        background-color: #fff;
        color: #66CCFF;
        border-color: #66CCFF;
    }

    .publish_operation_tools {
        display: flex;

    }

    .publish_title_input {
        font-size: 20px;
        padding: .375rem .75rem;
        width: 100%;
        line-height: 1.5;
        /*border: 0;*/
        border-bottom: #ccc 1px solid;
        outline: none;
        box-shadow: none;
        resize: none;
        color: #333;
        background: #f9f9f9;
    }

    .left-bar .menu-tabs {
        display: block !important;
        width: 100%;
    }

    .qa_item_div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        /*padding: 20px 0;*/
        border-bottom: 1px solid #eee;
    }

    .qa_item_question_div {
        display: flex;
        width: 83%;
    }

    .item_question {
        display: flex;
        flex-direction: column;
        padding: 0 15px;
        max-width: 83%;
        margin-top: -8px;
        /*max-width: 600px;*/
    }

    .item_question_avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        /*margin-left: 15px;*/
        /*margin-top: 36px;*/
    }

    .item_question_title {
        display: inline-block;
        white-space: nowrap;
        font-size: 18px;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #0181da;
        max-width: 100%;
        font-weight: bold
    }

    .item_question_base_info {
        margin-top: 8px;
        font-size: 13px;
        color: #9b9da2;
    }

    .item_view_answer_div {
        display: flex;
        width: 16%;
        /*margin: 0 30px;*/
        padding: 0 15px;
        justify-content: space-around;
    }

    .view_answer_div {
        display: flex;
        flex-direction: column;
        /*margin-right: 5px;*/
    }

    .view_answer_span {
        font-size: 14px;
        text-align: center;
    }

    .view_span {
        color: #6CF;
    }

    .level {
        color: #ffc500;
    }

    .item_question_content {
        /*line-height: 0px;*/
        margin-top: 11px;
    }

    .margin-right-10 {
        margin-right: 10px;
    }
</style>